import { createSlice } from "@reduxjs/toolkit";

const preferencesSlice = createSlice({
  name: "preferences",
  initialState: {
    apiLoading: {
      getPreferences: false,
      savePreferences: false,
    },
    preferences: {},
  },
  reducers: {
    setLoader(state, action) {
      state.apiLoading[action.payload.loaderKey] = action.payload.loaderValue;
    },
    setPreferences(state, action) {
      state.preferences = action.payload;
    },
    setQualityPreferences(state, action) {
      state.qualityPreferences = action.payload;
    }
  },
});

export const { setLoader, setPreferences, setQualityPreferences } = preferencesSlice.actions;

export default preferencesSlice.reducer;
